<div class="card-body">
  {{ "Systemreports.brushpickup.desctext" | translate }}
  <div class="form-row pb-5">
    <div class="col-3"></div>
    <div class="col-2">
      <span id="fDateID">{{ "Systemreports.brushpickup.fromdate" | translate }}:</span>
    </div>
    <div class="col-7">
      <div class="form-group d-flex">
        <mat-form-field appearance="outline">
          <mat-label>Start Date</mat-label>
          <input matInput [matDatepicker]="startDatePicker" autocomplete="off" [(ngModel)]="startDate" [max]="endDate" />
          <mat-datepicker-toggle matSuffix [for]="startDatePicker"></mat-datepicker-toggle>
          <mat-datepicker #startDatePicker></mat-datepicker>
        </mat-form-field>
      </div>
    </div>
  </div>
  <div class="form-row pb-5">
    <div class="col-3"></div>
    <div class="col-2">
      <span id="tDateID">{{ "Systemreports.brushpickup.todate" | translate }}:</span>
    </div>
    <div class="col-7">
      <div class="form-group d-flex">
        <mat-form-field appearance="outline">
          <mat-label>End Date</mat-label>
          <input matInput [matDatepicker]="endDatePicker" [max]="todayDate" [min]="startDate" [(ngModel)]="endDate" autocomplete="off" />

          <mat-datepicker-toggle matSuffix [for]="endDatePicker"></mat-datepicker-toggle>
          <mat-datepicker #endDatePicker></mat-datepicker>
        </mat-form-field>
      </div>
    </div>
  </div>
</div>
<div class="card-footer text-right">
  <button type="button" class="btn btn-primary" [attr.aria-label]="'' + 'Systemreports.btn.generatereport' | translate" (click)="openReports()">{{ "Systemreports.btn.generatereport" | translate }}</button>
</div>
